import script from "./ECommerceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ECommerceView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__